 import { CalculatePriceAction, CalculatePriceReserveAction, CalculatePrice_Pickup_Action, CalculatePrice_PickupDelivery_Action } from "../../../Redux/actions/actions";
import { SetPriceNewOrder } from "../../../Redux/actions/actionNames";
const workerUrl = new URL('./test.worker.js', import.meta.url);

export const CalculatePrice_PickupDelivery_Worker = (data, dispatch, noHttpOrder) => {

  const worker = new Worker(workerUrl );
  worker.postMessage(JSON.stringify(data))
  worker.addEventListener("message", (event) => {

    if (event.data.succeessfull) {
      if (noHttpOrder) {
        dispatch(SetPriceNewOrder({}, { done: true }));
      } else {
        dispatch(CalculatePrice_PickupDelivery_Action(dispatch, event.data.data));
      }
    } else {
      dispatch(SetPriceNewOrder({ done: false }, { done: false,where:"203"  }));
    }
    worker.terminate();
  });
};
